import { Button, Modal } from "antd";
import { useState } from "react";

export const ResendActivationEmailButton = ({
  licenseId,
  onResend,
}: {
  licenseId: number;
  onResend: (licenseId: number) => Promise<void> | void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await onResend(licenseId);
      setIsOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button
        className="base-button-outline w-[66px] h-[41px]"
        onClick={() => setIsOpen(true)}
      >
        再送信
      </Button>
      <Modal
        open={isOpen}
        onOk={handleSubmit}
        onCancel={() => setIsOpen(false)}
        confirmLoading={isSubmitting}
        okText="送信"
        cancelText="キャンセル"
        closeIcon={false}
        footer={() => (
          <div className="flex justify-center gap-[10px] mt-4">
            <Button
              onClick={() => setIsOpen(false)}
              className="base-button-outline w-[101px] h-[32px]"
            >
              いいえ
            </Button>
            <Button
              onClick={handleSubmit}
              className="base-button w-[101px] h-[32px]"
              loading={isSubmitting}
            >
              はい
            </Button>
          </div>
        )}
      >
        <p className="mb-4 font-medium text-xl text-center">
          ライセンス有効化メール再送
        </p>
        <p className="mb-0">
          License ID: {licenseId} の有効化メールをエンドユーザーへ再送します。
        </p>
      </Modal>
    </>
  );
};
